import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const WidgetContainer = styled.div`
  width: 300px;
  min-height: 323px;
  background-color: ${customPalette.accent.white};
  border-radius: 8px;
  color: ${customPalette.accent.main};
  padding: 12px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const WidgetTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  font-family: Nunito;
  line-height: 130%;
  letter-spacing: 0.15px;
  color: ${customPalette.accent.main};
  margin-bottom: 12px;
  margin-top: 12px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  tbody tr:last-of-type td {
    border-bottom: none;
  }
`;

export const TableHeaderCell = styled.th`
  font-size: 14px;
  font-weight: 700;
  font-family: Nunito;
  line-height: 150%;
  color: ${customPalette.accent.main};
  text-align: left;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 6px;
  padding-left: 6px;

  text-align: left;

  &:nth-of-type(2),
  &:nth-of-type(3) {
    text-align: right;
  }

  &:nth-of-type(1) {
    width: 24%; /* Year */
  }
  &:nth-of-type(2) {
    width: 38%; /* Sampl. % */
  }
  &:nth-of-type(3) {
    width: 38%; /* Delivery cat. */
  }
`;

export const TableRowCell = styled.td`
  font-size: 14px;
  font-weight: 600;
  font-family: Nunito;
  line-height: 150%;
  color: ${customPalette.accent.main};
  padding: 12px 8px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;

  white-space: normal;
  word-break: break-word;

  text-align: left;
  &:nth-of-type(2),
  &:nth-of-type(3) {
    text-align: right;
  }

  &:nth-of-type(1) {
    width: 24%; /* Year */
  }
  &:nth-of-type(2) {
    width: 38%; /* Sampl. % */
  }
  &:nth-of-type(3) {
    width: 38%; /* Delivery cat. */
  }
`;
